import { Grid } from "@mui/material";
import FormTextField from "app/components/form-components/FormTextField";
function AddExpRequirements({ control, handleMaxExpBlur, handleMinExpBlur, preloadedData }) {
  return (
    <Grid container spacing={3} alignItems={"center"}>
      <Grid item xs={12} md={6}>
        <FormTextField
          control={control}
          name={"jp_min_exp"}
          label={"Min experience (years) "}
          onBlur={handleMinExpBlur}
          defaultValue={preloadedData ? preloadedData.jp_min_exp : "0"}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormTextField
          control={control}
          onBlur={handleMaxExpBlur}
          name={"jp_max_exp"}
          defaultValue={preloadedData ? preloadedData.jp_max_exp : "0"}
          label={"Max experience (years) "}
          fullWidth
        />
      </Grid>
    </Grid>
  );
}

export default AddExpRequirements;
